import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { createBikeHpiCheck } from '../../requests/bike_hpi_check_request';
import { createBikeHpiCheckSuccess, createBikeHpiCheckFailure } from '../actions/bike_hpi_check.actions';
import { CREATE_BIKE_HPI_CHECK } from '../constants/bike_hpi_check.constants';
import { message_success, message_error } from '../../../../../components/Message';
import { getLeadProfileWithApprovals } from '../../requests/get_lead_profile_request';

function* createBikeHpiCheckRequest({ bike_id }) {
    const {
        result, msg, error, options,
    } = yield call(createBikeHpiCheck, bike_id);
    if (result) {
        const store = yield select();
        const approvals = yield call(getLeadProfileWithApprovals, store.Leads.Lead_profile.Lead_general.root_id);
        if (approvals.result) {
            yield put({ type: 'CHECK_APPROVAL', payload: approvals.options.approval });
        }
        yield put(createBikeHpiCheckSuccess(options));
        message_success(msg);
    } else {
        yield put(createBikeHpiCheckFailure(error));
        message_error(error.message);
    }
}

export default function* createBikeHpiCheckSaga() {
    yield takeEvery(CREATE_BIKE_HPI_CHECK, createBikeHpiCheckRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/create_bike_hpi_check.saga.js